import { composeIO } from 'react-compose-io'
import RegraTransformacaoApiFormView from './RegraTransformacaoApiForm.View'
import { regraTransformacaoApiFormIO } from './RegraTransformacaoApiForm.IO'

export const RegraTransformacaoApiForm = composeIO(RegraTransformacaoApiFormView, regraTransformacaoApiFormIO)
